/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar4(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M12.155 9.988c-3.715 0-7.423-.692-10.559-2.073l.807-1.83c5.68 2.502 13.401 2.554 19.212.134l.77 1.846c-3.08 1.284-6.658 1.923-10.23 1.923z"/><path d="M19 8h-2V5H7v3H5V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4zM8.333 13h-.322C7.452 13 7 12.491 7 11.863v-.726C7 10.509 7.452 10 8.011 10H9.99c.558 0 1.01.509 1.01 1.137C11 12.166 9.667 13 8.333 13zM15.583 13h.313c.541 0 .979-.509.979-1.137v-.726c0-.628-.438-1.137-.979-1.137h-1.917c-.541 0-.979.509-.979 1.137C13 12.166 14.292 13 15.583 13z"/><path d="M13 22h-2c-1.458 0-3.177-1.295-3.868-2.504l-1.98-3.956c-.699-.891-2.552-3.51-1.712-5.259C3.722 9.697 4.394 9 6 9v2c-.56 0-.746.125-.757.148-.198.411.563 2.01 1.538 3.227l.113.178 2 4C9.268 19.203 10.403 20 11 20h2c.597 0 1.732-.797 2.132-1.496l2.087-4.128c.973-1.221 1.735-2.819 1.538-3.228C18.746 11.125 18.56 11 18 11V9c1.606 0 2.278.697 2.56 1.281.841 1.749-1.013 4.368-1.712 5.259l-1.953 3.907C16.177 20.705 14.458 22 13 22z"/><path d="M15 21H9a1 1 0 0 1-1-1v-2c0-1.227 1.425-3 4-3s4 1.773 4 3v2a1 1 0 0 1-1 1zm-5.001-2H14v-1c-.037-.2-.612-1-2-1s-1.963.8-2.002 1.025l.001.975z"/><path opacity=".3" d="M6 4v4l6 1 6-1V4z"/></svg>
  );
}

export default Avatar_icn_avatar4;
